import { QuestionForm } from "@/pages/campaign-form/components/campaigns/personalizedMessages/components/CustomQuestions/CreateQuestionModal"

const { TagType } = DjangIO.app.person.types

export const OPTION_TYPES: number[] = [TagType.single_option_list.value, TagType.multi_options_list.value]

export const validateQuestionForm = (form: QuestionForm) => {
    const errors: Record<string, string> = {}

    if (!form.name) errors.name = "Label is required"

    if (OPTION_TYPES.includes(form.tag_type)) {
        const isFilled = form.options_new.every((option) => option.value)
        if (!isFilled) errors.tag_type = "All options are required"

        const hasDuplicatedOptions =
            new Set(form.options_new.map((option) => option.value)).size !== form.options_new.length
        if (hasDuplicatedOptions) errors.tag_type = "You cannot have duplicated options"
    }
    return errors
}

export const formatDataToSubmit = (data: QuestionForm): Partial<QuorumModel["CustomTag"]> => {
    const formattedOptions = {}
    for (const option of data.options_new) {
        formattedOptions[`${option.value.toLowerCase()}_${option.slug}`] = option
        delete formattedOptions[`${option.value.toLowerCase()}_${option.slug}`].slug
    }

    const defaultValues = data.default_multi_value
        ? { default_multi_value: data.default_multi_value }
        : { default_string_value: data.default_string_value }

    return {
        name: data.name,
        external_name: data.name,
        tag_type: data.tag_type,
        tag_owner: DjangIO.app.models.QuorumDataType.supporter.value,
        organization: DjangIO.app.userdata.models.Organization.resourceUriFromId(Userdata.organization_id),

        is_personalized_question: true,
        is_editable: true,
        is_required: data.required,

        display_on_profile: data.add_as_custom_field,
        display_on_create_page: false,
        display_on_filters: data.add_as_custom_field,

        options_new: formattedOptions,

        ...defaultValues,
        default_boolean_value: data.default_boolean_value,
    }
}
